<template>
  <div class="pr-1">
    <br />
    <div id="second-bar-chart"></div>
    <br />
    <v-divider  style="margin: 0px 20px 0px 20px !important" />
    <br />
    <vue-good-table
      :columns="Columns"
      :rows="rows"
      style-class="vgt-table condensed bordered striped"
      row-style-class="tablerowheight"
      style="padding: 0px 20px 0px 20px !important"
      class="chart-table-sfrequency"
    >
      <template slot="table-column" slot-scope="props">
        <span class="tablerowheight">{{props.column.label}}</span>
      </template>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'sponsor'">
          <span style="text-align: center">{{props.row.sponsor}}</span>
        </span>
        <span v-if="props.column.field == 'count'">
          <span style="text-align: center">{{(props.row.count)}}</span>
        </span>
      </template>
    </vue-good-table>
  </div>
</template>


<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { mapState } from "vuex";
import adminSchema from "@/schemas/admin.json";
import colorValues from "values.js";

am4core.useTheme(am4themes_animated);

export default {
  name: "SecondSponsorsByAdFrequency",
  props: {
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    schema: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      rows: [],
      filteredRows: [],
      chartData: []
    };
  },
  computed: {
    ...mapState({
      portal: state => state.portal,
      clip: state => state.clip,
      gameID: state => state.game.gameID,
      secondSponByGameResult: state => state.clip.secondSponByGameResult
    }),
    Columns() {
      return adminSchema.clipsBarChart.columns;
    }
  },
  watch: {
    secondSponByGameResult: {
      handler: function() {
        this.rows = this.secondSponByGameResult;
        this.rows = [];
        this.filteredRows = [];
        this.computeAdFrequency();
      },
      immediate: true,
      deep: true
    },
    Columns: {
      handler: function() {
        this.tableCol = this.Columns;
      }
    }
  },
  methods: {
    changeTimeFormat(time) {
      var s = Math.floor(time % 60);
      var m = Math.floor((time / 60) % 60);
      var h = Math.floor(time / 3600);
      if (isNaN(time) || time === Infinity) {
        h = m = s = "--";
      }
      h = h > 0 ? h + ":" : "";
      m = (h && m < 10 ? "0" + m : m) + ":";
      s = s < 10 ? "0" + s : s;
      return (time = h + m + s);
    },
    computeAdFrequency() {
      /*
       let new_arr = this.secondSponByGameResult.reduce((ar, obj) => {
        let bool = false;
        if (!ar) {
          ar = [];
        }
        ar.forEach(a => {
          if (a.sponsor === obj.sponsor) {
            a.count++;
            bool = true;
          }
        });
        if (!bool) {
          obj.count = 1;
          ar.push(obj);
        }
        return ar;
      }, []);
      this.rows = new_arr;
      */

      var filteredRows = this.secondSponByGameResult

      filteredRows = this.$_(filteredRows)
        .groupBy('sponsor')
        .map((objs, key) => {
          return {
            'sponsor': key,
            'count': this.$_.sumBy(objs, (x) => (x) ? 1 : 0) //this.$_.countBy(objs),
          }
        })
        .value()
      filteredRows = this.$sortBy(filteredRows, 'count')
      filteredRows = filteredRows.reverse();
      filteredRows = filteredRows.slice(0,5);
      filteredRows = filteredRows.reverse();
      this.rows = filteredRows;



      //console.log("New arr :" + JSON.stringify(new_arr, null, 2));
    },
    createChart() {
      // Create chart instance
      var chart = am4core.create("second-bar-chart", am4charts.XYChart);
      chart.marginRight = 400;

      // Add data
      chart.data = this.rows;

      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "sponsor";
      categoryAxis.title.text = "Sponsors";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;

      categoryAxis.renderer.inside = true;
      categoryAxis.fontSize = 13;
      categoryAxis.renderer.labels.template.fill = "#ffffff";    
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.labels.template.rotation = 270;  
      categoryAxis.renderer.labels.template.verticalCenter = "left";
      categoryAxis.renderer.labels.template.horizontalCenter = "left";





      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.dataFields.value = "count";
      valueAxis.title.text = "Frequency";

      // Create series
      var series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "count";
      series.dataFields.categoryX = "sponsor";
      series.name = "Frequency";
      series.tooltipText = "{name}: [bold]{count}[/]";
      series.stacked = true;
     
      series.columns.template.adapter.add("fill", function(fill, target) {
        return chart.colors.getIndex(target.dataItem.index);
      });

      // // Set Color acording to Theme
      // var colorList = [];
      // new colorValues(this.portal.active.secondary)
      //   .tints(9)
      //   .forEach(function(color) {
      //     colorList.push("#" + color.hex);
      //   });
      // //console.log("colorList = ", JSON.stringify(colorList, null, 2))
      // //var colorSet = new am4core.ColorSet();
      // //colorSet.list = colorList.map(function(color) {
      // //      return new am4core.color(color);
      // //});

      // series.columns.template.adapter.add("fill", (fill, target) => {
      //   return am4core.color(colorList[target.dataItem.index]).lighten(0.5);
      // });

      series.strokeWidth = 0;

      // Add cursor
      chart.cursor = new am4charts.XYCursor();
    },
     orientationChange() {
      this.createChart();
      //console.log("Orientation changed");
    },
    resize() {
      this.createChart();
      //console.log("Page resized");
    }
  },
  
  created() {
    var v = this;
   window.addEventListener("orientationchange", v.orientationChange, false);
    window.addEventListener("resize", v.resize, false);
  },
  beforeUpdate() {
    this.createChart();
  },
  mounted() {
    this.createChart();
  },
    beforeDestroy(){
    window.removeEventListener("orientationchange", this.orientationChange);
    window.removeEventListener("resize", this.resize);
  }
};
</script>


<style>
#second-bar-chart {
  width: 100%;
  height: 450px;
}

.chart-table-sfrequency .vgt-table.condensed td, .vgt-table.condensed th.vgt-row-header{
  padding: 0.4em 2.4em .4em 1.4em !important;
  font-size: 14px !important;
}

.chart-table-sfrequency .vgt-table th{
  padding: 0.4em 0.8em .4em 0.8em !important;
}

.chart-table-sfrequency .tablerowheight{
  font-size: 16px !important;
}
</style>

